import { useState, useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./style/LandindPages.scss";
import moment from "moment-timezone";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import Base from "./Components/Layout/Base";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Signup from "./Components/Elements/Signup";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./Components/Elements/Login";
import PrivateRoute from "./Components/Elements/PrivateRoute";
import Profile from "./Components/Elements/Profile/Profile";
import Contract from "./Components/Elements/Contract/Contract";
import Enterprises from "./Components/Elements/Enterprises/Enterprises";
import NewEnterprises from "./Components/Elements/Enterprises/NewEnterprises";
import Team from "./Components/Elements/Team/Team";
import Invities from "./Components/Elements/Invities/Invities";
import UpdateContract from "./Components/Elements/Contract/UpdateContract";
import UpdateEntreprises from "./Components/Elements/Enterprises/UpdateEntreprises";
import UpdateTeam from "./Components/Elements/Team/UpdateTeam";
import Users from "./Components/Elements/User/Users";
import ContractLinkEntreprises from "./Components/Elements/LinkPages/ContractLinkEntreprises";
import ContractToTeam from "./Components/Elements/LinkPages/ContractToTeam";
import EntreprisesToTeam from "./Components/Elements/LinkPages/EntreprisesToTeam";
import global_en from "./translations/en/global.json";
import global_fr from "./translations/fr/global.json";
import i18next from "i18next";
import CopyContract from "./Components/Elements/Contract/CopyContract";
import CopyClosedContract from "./Components/Elements/Contract/CopyClosedContract";
import ReadContract from "./Components/Elements/Contract/ReadContract";
import UpdateUser from "./Components/Elements/User/UpdateUser";
import ContractToUser from "./Components/Elements/LinkPages/ContractToUser";
import EnterprisesToUser from "./Components/Elements/LinkPages/EnterprisesToUser";
import MeetingTabs from "./Components/Elements/Meeting/MeetingTabs";
import ActionPlay from "./Components/Elements/Actions/ActionPlay";
import Invite from "./Components/Elements/Meeting/CurrentMeeting/Invite";
import { CounterContextProvider } from "./Components/Elements/Meeting/context/CounterContext";
import UpdatePassword from "./Components/Elements/User/UpdatePassword";
import axios from "axios";
import { API_BASE_URL } from "./Components/Apicongfig";
import Report from "./Components/Elements/Meeting/Report";
// import CustomerSupport from "./Components/Elements/CustomerSupport";
import CompletedInvite from "./Components/Elements/Meeting/CompletedMeeting/CompletedInvite";
import DestinationToMeetings from "./Components/Elements/Invities/DestinationToMeeting/DestinationToMeetings";
import BasePage from "./Components/Layout/BasePage";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Privacypolicy from "./Pages/Privacypolicy";
import Termsandconditions from "./Pages/Termsandconditions";
import Contactus from "./Pages/Contactus";
import Planandpricing from "./Pages/Planandpricing";
import AOS from "aos";
import "aos/dist/aos.css";
import ProfileInvitePage from "./Components/Elements/Profile/ProfileInvitePage";
import UseCase1 from "./Pages/UseCase1";
import UseCase2 from "./Pages/UseCase2.jsx";
import UseCase3 from "./Pages/UseCase3.jsx";
import UseCase4 from "./Pages/UseCase4.jsx";
import NewsletterTerms from "./Pages/NewsletterTerms.jsx";
import ActionTabs from "./Components/Elements/Actions/ActionTabs.jsx";
import SolutionTabs from "./Components/Elements/Solution/SolutionTabs.jsx";
import Solution from "./Components/Elements/Solution/GetSolution/Solution.jsx";
import CompletedDoneStep from "./Components/Elements/Meeting/CompletedMeeting/CompletedDoneStep.jsx";
import AddQuestionField from "./Components/Elements/QuestionsField/AddQuestionField.jsx";
// import TodoStepScreen from "./Components/Elements/Meeting/CompletedMeeting/TodoStepScreen.jsx";
import ZoomIntegrationGuide from "./Pages/ZoomIntegrationGuide.jsx";
import { StepCounterContextProvider } from "./Components/Elements/Meeting/context/StepCounterContext.js";
import CreateUsers from "./Components/Elements/User/CreateUsers.jsx";
import ForgotPasswordPage from "./Components/Elements/ForgotPasswordPage.jsx";
import ClientDetail from "./Components/Elements/Team/Client/ClientDetail.jsx";
import MemberDetail from "./Components/Elements/Team/Member/MemberDetail.jsx";
import ViewMeeting from "./Components/Elements/Meeting/ViewMeeting.jsx";
import { getFcmToken, messaging } from "./firebase.js";
import { onMessage } from "firebase/messaging";
import { closeSnackbar, useSnackbar } from "notistack";
import notificationSound from "./Media/notification.mp3";
import MeetingPreview from "./Components/Elements/Meeting/MeetingPreview.jsx";
import { setupAxiosInterceptors } from "./Components/Utils/auth.js";
import ContactDetail from "./Components/Elements/Team/Contact/ContactDetail.jsx";
import CastingMemberDetail from "./Components/Elements/Team/Member/CastingMemberDetail.jsx";
import CastingContactDetail from "./Components/Elements/Team/Contact/CastingContactDetail.jsx";
import Register from "./Components/Elements/Register.jsx";
import ReferralLanding from "./Components/Elements/ReferralLanding.jsx";
import DiscussionTabs from "./Components/Elements/Discussion/DiscussionTabs.jsx";

i18next.init({
  interpolation: { escapevalue: false },
  lng: "en",
  resources: {
    en: {
      global: global_en,
    },
    fr: {
      global: global_fr,
    },
  },
});

// Define all valid public and private routes
const publicRoutes = [
  "/",
  "/login",
  "/signup",
  "/about",
  "/contact",
  "/privacy-policy",
  "/terms&conditions",
  "/contactus",
  "/pricing",
  "/useCase/1",
  "/useCase/2",
  "/useCase/3",
  "/useCase/4",
];

const privateRoutes = [
  "/profile",
  "/contract",
  "/CopyContract",
  "/CopyClosedContract",
  "/ModifierContract",
  "/ContractLinkEnterprises",
  "/readContract",
  "/ContractToTeam",
  "/ContractToUser",
  "/EntreprisesToTeam",
  "/EntreprisesToUsers",
  "/Enterprises",
  "/NewEnterprises",
  "/ModifierEnterprises",
  "/Team",
  "/ModifierTeam",
  "/Users",
  "/ModifierUser",
  "/Invities",
  "/invitiesToMeeting",
  "/participantToAction",
  "/updateParticipant",
  "/meeting",
  "/updatepassword",
  "/meetingDetail",
  "/play",
  "/actīon/play",
  "/PlayMeeting",
  "/view",
  "/invite",
  "/destination/:unqiue_id/:meeting_id",
  "/newsletter/terms-and-conditions",
  "/present/invite",
  "/step",
  "/todo-step",
  "/action",
  "/solution",
  "/question",
  "/solution",
];

// Function to check if the route is valid
const isValidRoute = (path, isSignedIn) => {
  return publicRoutes.includes(path) || privateRoutes.includes(path);
};

function App() {
  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();
  const [isSignedIn, setIsSignedIn] = useState(() => {
    return localStorage.getItem("isSignedIn") === "true";
  });

  // useEffect(() => {
  //   // Setup axios interceptors
  //   setupAxiosInterceptors(navigate);

  // }, [navigate]);

  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("🔔 Foreground message received:", payload);

      const title =
        payload.notification?.title ||
        payload.data?.title ||
        "New Notification";
      const body = payload.notification?.body || payload.data?.body || "";
      const image =
        payload.notification?.image ||
        payload.data?.image ||
        "/icons/icon-192x192.png";

      // Play sound
      const audio = new Audio(notificationSound);
      audio.play().catch((err) => console.log("Sound error:", err));

      enqueueSnackbar(body, {
        variant: "default",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
        autoHideDuration: 5000,
        content: (key, message) => {
          const url =
            payload.data?.click_action || payload.notification?.click_action;

          return (
            <div
              key={key}
              onClick={() => {
                if (url) {
                  navigate(url, { state: { from: "meeting" } });
                }
                closeSnackbar(key);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                background: "linear-gradient(135deg, #ffffff, #f9f9f9)",
                padding: "1.25rem",
                borderRadius: "16px",
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
                maxWidth: 420,
                width: "100%",
                gap: "1rem",
                cursor: "pointer",
                animation: "fadeSlideIn 0.3s ease",
                fontFamily: `'Inter', sans-serif`,
              }}
            >
              <img
                src={image || "/icons/icon-192x192.png"}
                alt="Notification"
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: "12px",
                  objectFit: "cover",
                  objectPosition: "left",
                  flexShrink: 0,
                }}
              />

              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: "17px",
                    fontWeight: 700,
                    color: "#1a1a1a",
                    marginBottom: "0.35rem",
                  }}
                >
                  {title || "New Notification"}
                </div>

                <div
                  style={{
                    fontSize: "15px",
                    color: "#4a4a4a",
                    lineHeight: 1.4,
                  }}
                >
                  {message}
                </div>
              </div>

              <style>
                {`
          @keyframes fadeSlideIn {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
              </style>
            </div>
          );
        },
      });
    });

    return () => unsubscribe();
  }, [enqueueSnackbar, closeSnackbar]);

  //   useEffect(()=>{
  //     // getFcmToken()
  //  // Handle incoming messages when app is in foreground
  // onMessage(messaging, (payload) => {
  //   console.log("Foreground message received:", payload);

  //   // Customize how you want to show the notification
  //   const notificationTitle = payload.notification?.title || payload.data?.title;
  //   const notificationOptions = {
  //     body: payload.notification?.body || payload.data?.body,
  //     icon: '/icons/icon-192x192.png',
  //     image: payload.notification?.image || payload.data?.image
  //   };

  //   // Show notification using the Notification API
  //   if (Notification.permission === "granted") {
  //     new Notification(notificationTitle, notificationOptions);
  //   } else {
  //     console.log("Notification permission not granted");
  //   }
  // });
  //   },[])
  const [removeLogo, setRemoveLogo] = useState(false);

  const signin = () => {
    setIsSignedIn(true);
    setRemoveLogo(true);
  };

  const signout = async () => {
    const logoutTime = new Date().toLocaleString(); // Get logout time in user's timezone
    localStorage.setItem("logoutTime", logoutTime);
    setIsSignedIn(false);
    setRemoveLogo(false);
    localStorage.removeItem("isSignedIn");
    navigate("/");
    await updateUser(); // Here update the database with logout time if possible
    sessionStorage.clear();
    localStorage.clear();
  };

  useEffect(() => {
    const userTimezone = moment.tz.guess();

    localStorage.setItem("timezone", userTimezone);
  }, []);

  // Update function with optional beacon support
  const updateUser = async (useBeacon = false) => {
    const id = parseInt(sessionStorage.getItem("user_id"));
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const logoutTime = new Date();
    const formattedLogoutTime = logoutTime.toLocaleString("en-GB", {
      timeZone: userTimeZone,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    const payload = {
      user_id: id,
    };

    if (useBeacon) {
      const url = `${API_BASE_URL}/logout`;
      navigator.sendBeacon(url, JSON.stringify(payload));
    } else {
      try {
        const response = await axios.post(`${API_BASE_URL}/logout`, payload, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        });
        if (response.status === 200) {
        } else {
          console.error(
            "Failed to update activity time:",
            response?.data?.message
          );
        }
      } catch (error) {
        console.error("Error updating User:", error);
      }
    }
  };

  useEffect(() => {
    localStorage.setItem("isSignedIn", isSignedIn.toString());
  }, [isSignedIn]);

  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);
  function refreshAccessToken() {
    const refreshToken = localStorage.getItem("refresh_token");

    if (!refreshToken) {
      console.error("No refresh token available");
      return;
    }
    const userid = localStorage.getItem("user_id");

    axios
      .post(
        `${API_BASE_URL}/auth/refresh`,
        {
          // refresh_token: refreshToken,
          user_id: userid,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        if (response) {
          const newAccessToken = response.data.access_token;
          const newExpiresIn = response.data.expires_in; // e.g., 3598 seconds

          // Update the stored tokens and expiration time
          sessionStorage.setItem("access_token", newAccessToken);
          localStorage.setItem("access_token", newAccessToken);

          const newExpirationTime = Date.now() + newExpiresIn * 1000;
          sessionStorage.setItem("token_expiration_time", newExpirationTime);
          localStorage.setItem("token_expiration_time", newExpirationTime);

          // Set a new timeout to refresh the access token again
          setTimeout(refreshAccessToken, (newExpiresIn - 60) * 1000); // Refresh 1 minute before expiration
        }
      })
      .catch((error) => {
        handleInvalidToken();
      });
  }

  function handleInvalidToken() {
    sessionStorage.removeItem("access_token");
    localStorage.removeItem("access_token");
    sessionStorage.removeItem("refresh_token");
    localStorage.removeItem("refresh_token");
    sessionStorage.removeItem("token_expiration_time");
    localStorage.removeItem("token_expiration_time");
  }

  // Function to check token expiration and refresh
  function checkTokenExpiration() {
    const tokenExpirationTime =
      sessionStorage.getItem("token_expiration_time") ||
      localStorage.getItem("token_expiration_time");
    if (!tokenExpirationTime) return;

    const currentTime = Date.now();
    if (currentTime > tokenExpirationTime) {
      sessionStorage.removeItem("access_token");
      localStorage.removeItem("access_token");
      sessionStorage.removeItem("token_expiration_time");
      localStorage.removeItem("token_expiration_time");
      refreshAccessToken();
    } else {
      console.log("not expired now!");
    }
  }

  setInterval(checkTokenExpiration, 60 * 1000);
  const location = useLocation();

  useEffect(() => {
    // Redirect to Home if the route is not valid
    // if (!isValidRoute(location.pathname, isSignedIn)) {
    //   navigate("/", { replace: true });
    // }
  }, [location.pathname, isSignedIn, navigate]);

  return (
    <div>
      <ToastContainer
        style={{
          position: "abosolute",
          zIndex: "101",
        }}
      />

      <Routes>
        <Route path="/" element={<Login onLogin={signin} />} />
        <Route
          path="/heroes/:nick_name/emissary/:referral_id"
          element={<ReferralLanding />}
        />
<Route path="/register/:referral_id?" element={<Register />} />


        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          element={
            <Base
              isAuthenticated={isSignedIn}
              onLogout={signout}
              onLogin={signin}
              onRemove={removeLogo}
            />
          }
        >
          {sessionStorage.getItem("type") === "MasterAdmin" &&
            sessionStorage.getItem("type") != "SuperAdmin" &&
            sessionStorage.getItem("type") != "Admin" && (
              <Route
                path="/contract"
                element={
                  <PrivateRoute isSignedIn={isSignedIn}>
                    <Contract onLogout={signout} />
                  </PrivateRoute>
                }
              />
            )}
          <Route
            path="/CopyContract/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CopyContract onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/CopyClosedContract/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CopyClosedContract onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/ModifierContract/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <UpdateContract onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/ContractLinkEnterprises/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ContractLinkEntreprises onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/readContract/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ReadContract onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/ContractToTeam/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ContractToTeam onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/ContractToUser/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ContractToUser onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/EntreprisesToTeam/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <EntreprisesToTeam onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/EntreprisesToUsers/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <EnterprisesToUser onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/Enterprises"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <Enterprises onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/NewEnterprises"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <NewEnterprises onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/ModifierEnterprises/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <UpdateEntreprises onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/Team"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <Team onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/client/:id"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ClientDetail onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/member/:id"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <MemberDetail onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/casting/member/:destination_id/:id"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CastingMemberDetail onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/contact/:id"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ContactDetail onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/casting/contact/:destination_id/:id"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CastingContactDetail onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/discussion"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <DiscussionTabs onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/ModifierTeam/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <UpdateTeam onLogout={signout} />
              </PrivateRoute>
            }
          />

          <Route
            path="/Users/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <Users onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/user/create"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CreateUsers onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/ModifierUser/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <UpdateUser onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/Invities"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <Invities onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/invitiesToMeeting/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <DestinationToMeetings onLogout={signout} />
              </PrivateRoute>
            }
          />

          {/* <Route
            path="/participantToAction/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ParticipantToAction onLogout={signout} />
              </PrivateRoute>
            }
          /> */}

          {/* <Route
            path="/updateParticipant/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <UpdateParticipant onLogout={signout} />
              </PrivateRoute>
            }
          /> */}

          <Route
            path="/meeting"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <MeetingTabs onLogout={signout} />
              </PrivateRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <Profile onLogout={signout} />
              </PrivateRoute>
            }
          />
          {/* UpdatePassword Route */}
          <Route
            path="/updatepassword"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <UpdatePassword onLogout={signout} />
              </PrivateRoute>
            }
          />

          {/* <Route
            path="/participant/:id"
            element={<UpdateParticipant onLogout={signout} />}
          /> */}

          {/* <Route
            path="/play/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CounterContextProvider>
                  <Play onLogout={signout} />
                </CounterContextProvider>
              </PrivateRoute>
            }
          /> */}
          <Route
            path="/actīon-play/:id/:step_Id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <StepCounterContextProvider>
                  <ActionPlay onLogout={signout} />
                </StepCounterContextProvider>
              </PrivateRoute>
            }
          />

          {/* <Route
            path="/PlayMeeting/:id"
            element={
              <CounterContextProvider>
                <PlayMeeting />
              </CounterContextProvider>
            }
          /> */}
          <Route
            path="/view/:id"
            element={<MeetingPreview onLogout={signout} />}
          />
          <Route
            path="/heroes/:nick_name"
            element={<ProfileInvitePage onLogout={signout} />}
          />

          <Route
            path="/invite/:id"
            element={
              // <StepCounterContextProvider>
                <Invite onLogout={signout} />
              // </StepCounterContextProvider>
            }
          />
          <Route
            path="/destination/:unqiue_id/:meeting_id"
            element={
              <CounterContextProvider>
                <Report />
              </CounterContextProvider>
            }
            // element={<Presentationreport />}
          />
          <Route
            path="/newsletter/terms-and-conditions"
            element={<NewsletterTerms />}
            // element={<Presentationreport />}
          />

          <Route
            path="/present/invite/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CompletedInvite onLogout={signout} />
              </PrivateRoute>
            }
          />

          <Route
            path="/step/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CompletedDoneStep onLogout={signout} />
              </PrivateRoute>
            }
          />
          {/* <Route
            path="/todo-step/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <TodoStepScreen onLogout={signout} />
              </PrivateRoute>
            }
          /> */}
          {/* <Route
            path="/customer-support"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CustomerSupport onLogout={signout} />
              </PrivateRoute>
            }
          /> */}
          <Route
            path="/action"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <StepCounterContextProvider>
                  <ActionTabs onLogout={signout} />
                </StepCounterContextProvider>
              </PrivateRoute>
            }
          />

          <Route
            path="/solution"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <SolutionTabs onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/question"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <AddQuestionField onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/solution/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <Solution onLogout={signout} />
              </PrivateRoute>
            }
          />
        </Route>
        {/* Wildcard Route - Redirects Based on Auth Status */}
        <Route
          path="*"
          element={
            isSignedIn ? (
              <Navigate to="/Team" replace />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
          <Route path="/home" element={<Home />} />
      </Routes>

      <BasePage>
        <Routes>
          {/* <Route path="/" element={<Login />} /> */}
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contactus />} />
          <Route path="/privacy-policy" element={<Privacypolicy />} />
          <Route path="/terms&conditions" element={<Termsandconditions />} />
          <Route
            path="/docs/zoom-integration-guide"
            element={<ZoomIntegrationGuide />}
          />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/pricing" element={<Planandpricing />} />
          <Route path="/useCase/1" element={<UseCase1 />} />
          <Route path="/useCase/2" element={<UseCase2 />} />
          <Route path="/useCase/3" element={<UseCase3 />} />
          <Route path="/useCase/4" element={<UseCase4 />} />
        </Routes>
      </BasePage>
    </div>
  );
}

export default App;
